import LanguageDetector from 'i18next-browser-languagedetector'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'

import store from '@common/oneclub/store'

import { setLanguage } from '@common/oneclub/store/languageSlice'
import { LANGUAGE } from '@common/oneclub/constants'
import { getLocalLang } from './utils'
const localLang = getLocalLang()

export const noLang = {
  label: '显示多语言key',
  lang: 'nokey',
  languageType: 'nokey' as 'en',
  antd: 'nokey_NO',
}
export const canShowI18nKey = process.env.APP_ENV !== 'product'
if (canShowI18nKey) {
  const t = i18n.t
  i18n.t = (...args) => (i18n.language === noLang.lang ? args[0] : t.call(i18n, ...args))
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: function (lngs: string[]) {
        const lng = lngs[0]
        if (lng === 'zh' || lng === 'zh-CN') {
          return `${process.env.I18N_URL}/zh-hans-cn.json?lng=${lng}`
        }
        if (lng === 'zh-TW') {
          return `${process.env.I18N_URL}/zh-hant-tw.json?lng=${lng}`
        }
        if (lng === 'zh-HK') {
          return `${process.env.I18N_URL}/zh-hant-hk.json?lng=${lng}`
        }
        return `${process.env.I18N_URL}/{{lng}}.json?lng=${lng}`
      },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    lng: localLang?.[0]?.lang,
    debug: false,
    supportedLngs: ['en', 'zh', 'zh-TW', 'zh-HK', 'zh-CN', 'vi', 'th', 'id'],
    keySeparator: '',
    load: 'currentOnly',
  })
  .then(() => {
    store.dispatch(setLanguage(localLang[0] || LANGUAGE.find((lang) => lang.languageType === 'en')))
  })

export default i18n
